// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-container-block',
    // #endregion
    // #region Properties
    data: () => ({
        _height: '0px',
        _width: '0px',
    }),
    // #endregion
    // #region Constructor
    mounted() {
        this._height = this.$refs['__container'].clientHeight + 'px';
        this._width = this.$refs['__container'].clientWidth + 'px';
    },
    // #endregion
    // #region Methods
    methods: {
        onResize() {
            this._height = this.$refs['__container'].clientHeight + 'px';
            this._width = this.$refs['__container'].clientWidth + 'px';
        },
    }
    // #endregion
});
// #endregion
